module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsValentine@2x.24afe70.webp";